export default __webpack_public_path__ + "static/media/save-active.7672af69.svg";